import Vue from 'vue';
import VueI18n from 'vue-i18n';
import en from './langs/en';
import zh from './langs/zh';
import kr from './langs/kr';
import ar from './langs/ar';
import { getUrlParams } from '@/utils';
import { parse, stringify } from 'querystring';
import { ref } from '@vue/composition-api';

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: getLocale(),
  messages: {
    en,
    zh,
    kr,
    ar
  }
});

export function getLocale() {
  const area = getUrlParams('area') || parse(location.href).area || localStorage.getItem('area') || 'en'; // 默认英文
  // console.log(area, '语言1111')
  switch (area) {
    case 'us':
    case 'en':
    case 'multi':
    case 'as':
    case 'eu':
      return 'en';
    case 'kr':
      return 'kr';
    case 'me':
      return 'ar';
    default:
      // 有area=sin的场景，不能返回area
      return 'zh';
  }
}

// 由于语言是根据url参数来判断的，然后在跳转时可能会设置不同的语言,在这里处理
export function handleI18nWhenLocaleChange() {
  const newLocale = getLocale();
  if (i18n.locale !== newLocale) {
    i18n.locale = newLocale;
  }
}

export default i18n;
